import { render, staticRenderFns } from "./CarrierMessageAlert.vue?vue&type=template&id=51adde08&scoped=true"
import script from "./CarrierMessageAlert.vue?vue&type=script&lang=js"
export * from "./CarrierMessageAlert.vue?vue&type=script&lang=js"
import style0 from "./CarrierMessageAlert.vue?vue&type=style&index=0&id=51adde08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51adde08",
  null
  
)

export default component.exports